import React, { useState, useEffect } from 'react';
import { Box, Card, Title, Text, TextInput, Button, Group, Stack, Table, ActionIcon, Textarea, Badge } from '@mantine/core';
import { IconTrash, IconCalendarEvent } from '@tabler/icons-react';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

export default function EventsManager({ userEmail }) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ title: '', description: '', eventDate: '', address: '' });

  const fetchEvents = () => {
    fetch(`${API_BASE_URL}/api/events?ownerEmail=${userEmail}`)
      .then(r => r.json())
      .then(setEvents)
      .catch(e => console.error(e));
  };

  useEffect(() => {
    if (userEmail) fetchEvents();
  }, [userEmail]);

  const handleCreate = () => {
    setLoading(true);
    fetch(`${API_BASE_URL}/api/events?ownerEmail=${userEmail}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...form, ownerEmail: userEmail })
    }).then(r => {
      if(r.ok) {
        setForm({ title: '', description: '', eventDate: '', address: '' });
        fetchEvents();
      }
    }).finally(() => setLoading(false));
  };

  const handleDelete = (id) => {
    if(!window.confirm("Delete event?")) return;
    fetch(`${API_BASE_URL}/api/events/${id}?ownerEmail=${userEmail}`, {
      method: 'DELETE'
    }).then(r => {
      if (r.ok) fetchEvents();
    });
  };

  return (
    <Box>
      <Title order={3} mb="md">Menedżer Wydarzeń (Events)</Title>
      <Text mb="lg" c="dimmed">
        Utwórz wydarzenie. System automatycznie znajdzie klientów w okolicy 50 km i wyśle im powiadomienia e-mail z zaproszeniem.
      </Text>

      <Card withBorder radius="md" mb="xl">
        <Stack gap="md">
          <TextInput 
            label="Tytuł wydarzenia" 
            value={form.title} 
            onChange={e => setForm({...form, title: e.target.value})} 
          />
          <TextInput 
            label="Data i czas" 
            type="datetime-local" 
            value={form.eventDate} 
            onChange={e => setForm({...form, eventDate: e.target.value})} 
          />
          <TextInput 
            label="Adres wydarzenia" 
            placeholder="np. ul. Marszałkowska 1, Warszawa"
            value={form.address} 
            onChange={e => setForm({...form, address: e.target.value})} 
          />
          <Textarea 
            label="Opis" 
            minRows={3} 
            value={form.description} 
            onChange={e => setForm({...form, description: e.target.value})} 
          />
          <Button onClick={handleCreate} loading={loading} leftSection={<IconCalendarEvent size={16}/>}>
            Utwórz Wydarzenie i Powiadom Okolicę
          </Button>
        </Stack>
      </Card>

      <Title order={4} mb="md">Twoje Nadchodzące Wydarzenia</Title>
      {events.length > 0 ? (
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Tytuł</Table.Th>
              <Table.Th>Data</Table.Th>
              <Table.Th>Adres</Table.Th>
              <Table.Th>Akcje</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {events.map(ev => (
              <Table.Tr key={ev.id}>
                <Table.Td>{ev.title}</Table.Td>
                <Table.Td>{new Date(ev.eventDate).toLocaleString()}</Table.Td>
                <Table.Td>{ev.address} {ev.latitude && <Badge color="green" size="xs">Geo OK</Badge>}</Table.Td>
                <Table.Td>
                  <ActionIcon color="red" onClick={() => handleDelete(ev.id)}><IconTrash size={16}/></ActionIcon>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      ) : (
        <Text c="dimmed">Brak wydarzeń.</Text>
      )}
    </Box>
  );
}
